// Global scope for callback function
(<any>window).recaptchaCallback = (recaptchaToken: string) => {
    $('#g-recaptcha-response').val(recaptchaToken); // Set token
    $('#btn-submit', 'form')[0].click(); // Submit form
};

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(() => {
        // Workaround for browser refresh, which could otherwise re-post the form and mess-up recaptcha.
        // @see https://dtbaker.net/files/prevent-post-resubmit.php
        if (window.history.replaceState) {
            window.history.replaceState(null, null, window.location.href);
        }

        // Form submission
        $('#btn-submit', 'form').on('click', (e) => {
            const isHumanClick = e.clientX !== 0 || e.clientY !== 0;
            if (isHumanClick) {
                // Don't submit on human click, but wait for recaptcha callback
                e.preventDefault();
                grecaptcha.execute();
            }
        });
    });
}